import { render, staticRenderFns } from "./XGChart.vue?vue&type=template&id=4f29aba8"
import script from "./XGChart.vue?vue&type=script&lang=js"
export * from "./XGChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports